import { createClient } from '@supabase/supabase-js';

// Supabase configuration from environment variables
// Required in .env.local or Cloudflare Pages environment variables:
// - VITE_SUPABASE_URL: Your Supabase project URL (e.g., https://xxxxx.supabase.co)
// - VITE_SUPABASE_ANON_KEY: Your Supabase anon/public key
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase environment variables are missing!');
  console.warn('Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment.');
  console.warn('For local development, create a .env.local file in the project root.');
  console.warn('For production, set them in Cloudflare Pages → Settings → Environment Variables.');
}

// Create Supabase client
// This will throw an error if URL or key is missing, which is intentional
// to catch configuration issues early
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
